import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Button } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { DirectTokenService } from '../services/DirectTokenService';
import { ScimAuthService } from '../services/ScimAuthService';

export const SignOutButton: React.FC = () => {
    const { instance } = useMsal();

    const handleLogout = (logoutType: string) => {
        const isDirectTokenAuth = ScimAuthService.isAuthenticated() && ScimAuthService.getCurrentAccount()?.environment === 'direct-token';
        
        if (isDirectTokenAuth) {
            DirectTokenService.clearDirectToken();
            window.location.reload();
            return;
        }

        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    };

    return (
        <Button
            variant="outline"
            color="gray.0"
            leftSection={<IconLogout size={16} />}
            onClick={() => handleLogout("redirect")}
            styles={{
                root: {
                    borderColor: 'rgba(255, 255, 255, 0.7)',
                    color: 'white',
                    '&:hover': {
                        borderColor: 'white',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    },
                },
            }}
        >
            Sign Out
        </Button>
    );
};
